import { tr } from "../i18n/idioma";

/* Lo común a los vídeos incrustados (2026-10-25): enfoque visible y olvido del consentimiento.
   La clave de localStorage es la de VideoYouTube.jsx. */

const CLAVES = ["yamacoa.youtube.siempre"];
export function olvidarConsentimientoVideos() {
  for (const k of CLAVES) { try { localStorage.removeItem(k); } catch { /* sin almacenamiento */ } }
}

// Enfoque del vídeo, a la vista: de quién es el punto de vista que se muestra.
export const ENFOQUE = () => ({
  testimonio: tr("Testimonio", "Testimony"), denuncia: tr("Denuncia", "Complaint"),
  periodistico: tr("Medio de comunicación", "News outlet"), opinion: tr("Opinión", "Opinion"),
  oficial: tr("Cuenta oficial del Estado cubano", "Official Cuban state account"),
});
export function EnfoqueVideo({ enfoque }) {
  if (!enfoque || !ENFOQUE()[enfoque]) return null;
  return (
    <span className={`y-badge ${enfoque === "oficial" ? "y-badge--neutro" : "y-badge--auto"}`} style={{ display: "inline-block", margin: "0 0 8px" }}>
      {ENFOQUE()[enfoque]}
    </span>
  );
}
